<template>
  <v-container>
      <h2 class="title text-center">{{texts.title}}</h2>
      <p class="text-center">{{texts.subtitle}}</p>
      <v-row>
        <v-col
        v-for="card in cards"
        :key="card.id"
        >
          <v-card
            class="mx-auto"
            max-width="344"
          >
            <v-img
              :src="card.img"
              height="200px"
            ></v-img>

            <v-card-title>
              {{card.title}}
            </v-card-title>

            <v-card-subtitle>
              {{card.text}}
            </v-card-subtitle>

            <v-card-actions>
              <v-btn text>Share</v-btn>

              <v-btn
                color="purple"
                text
              >
                Explore
              </v-btn>

              <v-spacer></v-spacer>

              <v-btn
                icon
                @click="show = !show"
              >
                <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
              </v-btn>
            </v-card-actions>

            <v-expand-transition>
              <div v-show="show">
                <v-divider></v-divider>

                <v-card-text>
                  I'm a thing. But, like most politicians, he promised more than he could deliver. You won't have time for sleeping, soldier, not with all the bed making you'll be doing. Then we'll go with that data file! Hey, you add a one and two zeros to that or we walk! You're going to do his laundry? I've got to find a way to escape.
                </v-card-text>
              </div>
            </v-expand-transition>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
export default {
  name: "Card",
  props: {
    cards: Array,
    texts: Object
  }

}
</script>

<style>

</style>